import { withPluginApi as __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__ } from "discourse/lib/plugin-api";
/******/ // The require scope
/******/ var __webpack_require__ = {};
/******/ 
/************************************************************************/
/******/ /* webpack/runtime/define property getters */
/******/ (() => {
/******/ 	// define getter functions for harmony exports
/******/ 	__webpack_require__.d = (exports, definition) => {
/******/ 		for(var key in definition) {
/******/ 			if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 				Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 			}
/******/ 		}
/******/ 	};
/******/ })();
/******/ 
/******/ /* webpack/runtime/hasOwnProperty shorthand */
/******/ (() => {
/******/ 	__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ })();
/******/ 
/************************************************************************/
var __webpack_exports__ = {};

;// external "discourse/lib/plugin-api"

;// ./src/plugin/assets/javascripts/discourse/initializers/init-composer-events.ts

/* harmony default export */ const init_composer_events = ({
    name: "waze-require-edit-reason-composer-events",
    initialize(_container, _app) {
        __WEBPACK_EXTERNAL_MODULE_discourse_lib_plugin_api_dfe1d9c2_withPluginApi__("2.1.0", (api) => {
            const editReasonService = api.container.lookup("service:enforce-edit-reason");
            api.onAppEvent("composer:open", () => {
                if (editReasonService.shouldEnforce) {
                    editReasonService.toggleState(true);
                }
            });
            api.onAppEvent("composer:closed", () => {
                editReasonService.toggleState(false);
            });
        });
    },
});

export { init_composer_events as default };
